import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

export function slugToNice(slug, cap = false) {
  let string = slug
  if (slug === 'extra_person_fee') {
    string = slug.replace('person', 'people')
  }

  return (
    string &&
    string
      .split('_')
      .map((word, wordIndex) =>
        word
          .split('')
          .map((letter, index) =>
            wordIndex === 0 && index === 0 && cap
              ? letter.toUpperCase()
              : letter,
          )
          .join(''),
      )
      .join(' ')
  )
}

export function capitalize(word) {
  return word
    .split('')
    .map((letter, index) => (index === 0 ? letter.toUpperCase() : letter))
    .join('')
}

export function camelize(slug) {
  return slug
    .split('-')
    .map((word) =>
      word
        .split('')
        .map((letter, index) => (index === 0 ? letter.toUpperCase() : letter))
        .join(''),
    )
    .join('')
}

export const titleCase = (str) => startCase(toLower(str))

export default slugToNice
